const classPrefix = 'product-banner';
const dataPrefix  = 'data-product-banner';

/**
 * Инициализируем все баннеры на странице
 */
document.querySelectorAll(`[${dataPrefix}]`).forEach(initBanner);

function initBanner(root) {
    const container = root.querySelector(`.${classPrefix}__container`);
    if (!container) return;

    // 1. Пытаемся взять inline‑стиль background, иначе — вычисленный стиль
    const inlineBg   = container.getAttribute('style')?.match(/background:\s*([^;]+)/i)?.[1];
    const computedBg = window.getComputedStyle(container).backgroundColor;
    const bgColor    = (inlineBg || computedBg || '').trim();

    // 2. Переводим цвет в RGB‑объект
    const rgb = toRgb(bgColor);
    if (!rgb) return;

    // 3. Яркость по формуле WCAG
    const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;

    // 4. Если фон светлый — добавляем модификатор
    if (brightness > 180) {
        root.classList.add(`${classPrefix}--light`);
    }
}

/**
 * Принимает '#fff', '#ffffff', 'rgb(255,255,255)', 'rgba(255,255,255,1)'
 * Возвращает {r, g, b} или null
 */
function toRgb(color) {
    if (color.startsWith('#')) {
        let hex = color.slice(1);
        if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
        const int = parseInt(hex, 16);
        return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255 };
    }

    if (color.startsWith('rgb')) {
        const nums = color.match(/\d+/g)?.map(Number);
        if (nums?.length >= 3) return { r: nums[0], g: nums[1], b: nums[2] };
    }

    return null;
}
